// React
import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Axios
import axios from 'axios';

// Telegram UI
import { AppRoot, ButtonCell, Cell, Chip, Input, IconButton, List, Multiselectable, Select, Section } from '@telegram-apps/telegram-ui';

// VK UI
import { Avatar, Button, Text } from '@vkontakte/vkui';
import { Icon20ShareOutline, Icon20CancelCircleOutline, Icon20DoorEnterArrowRightOutline } from '@vkontakte/icons';

// AntD Mobile
import { Picker, Collapse } from 'antd-mobile'

// Icons
import { ReactComponent as AddIcon } from "../assets/add.svg";
import { ReactComponent as ForceIcon } from "../assets/force.svg";
import { ReactComponent as MediaIcon } from "../assets/media.svg";
import { ReactComponent as OriginalIcon } from "../assets/original.svg";
import { ReactComponent as SourceIcon } from "../assets/source.svg";
import { ReactComponent as CancelIcon } from "../assets/cancel.svg";

// Lottie
import Lottie from 'react-lottie';
import shareLottie from '../lotties/share.json';

const tg = window.Telegram.WebApp;

const TeamPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, setGroups, setChannels, selectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [keywords, setKeywords] = useState(stream.keywords)
    const [negative, setNegative] = useState(stream.negative)
    const [team, setTeam] = useState(selectedGroup.team || [])
    const [keywordRef, setKeywordRef] = useState(null);
    const [negativeRef, setNegativeRef] = useState(null);

    const noUsersOpt = {
        loop: true,
        autoplay: true,
        animationData: shareLottie,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const deleteUser = (user_name, user_id) => {
        tg.showPopup({
            title: "Исключить пользователя",
            message: `Вы действительно хотите исключить пользователя ${user_name}?`,
            buttons: [
                { id: 'ok', type: 'destructive', text: 'Исключить' },
                { id: 'cancel', type: 'cancel' },
            ]
        }, (buttonId) => {
            if (buttonId === 'cancel') {
                console.log("Действие отменено");
            } else if (buttonId === 'ok') {
                handleDeleteUser(user_id);

            }
        });
    };

    const logout = () => {
        tg.showPopup({
            title: "Выход из команды",
            message: `Вы действительно хотите выйти из команды «${selectedGroup.name}»?`,
            buttons: [
                { id: 'ok', type: 'destructive', text: 'Выйти' },
                { id: 'cancel', type: 'cancel' },
            ]
        }, (buttonId) => {
            if (buttonId === 'cancel') {
                console.log("Действие отменено");
            } else if (buttonId === 'ok') {
                handleDeleteUser(tg.initDataUnsafe.user.id);
                setActivePanel('home');
                if (selectedGroup.id < 0) {
                    setChannels((prev) => prev.filter((channel) => channel.id !== selectedGroup.id));
                } else {
                    setGroups((prev) => prev.filter((group) => group.id !== selectedGroup.id));
                }
            }
        });
    };

    const handleDeleteUser = async (user_id) => {
        const url = 'https://api.gmpapp.ru/delete_from_team';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, tg_id: user_id }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                console.log(`User has been deleted from: ${selectedGroup.id}`);

                // Обновление состояния после успешного удаления
                setTeam(prevTeam => prevTeam.filter(user => user.user_id !== user_id));
            }
        } catch (error) {
            console.error('Error deleting user from team', error);
        }
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'team') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);


    const handleAddKeyword = async () => {
        const url = 'https://api.gmpapp.ru/save_keywords';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, keyword: keywordRef }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                if (keywordRef && !keywords.includes(keywordRef)) {
                    setKeywords((prevKeywords) => [...prevKeywords, keywordRef]);
                }
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
        finally {
            setKeywordRef('');
        }
    };

    const handleDeleteKeyword = async (keywordToRemove) => {
        const url = 'https://api.gmpapp.ru/delete_keywords';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, keyword: keywordToRemove }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                setKeywords((prevKeywords) => prevKeywords.filter(keyword => keyword !== keywordToRemove));
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
    };

    const handleKeywordsPress = (e) => {
        // Если нажата клавиша Enter или введен знак запятой
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault(); // Остановка стандартного поведения (например, добавление новой строки)
            handleAddKeyword(); // Вызов функции handleAddKeyword
        }
    };

    const handleAddNegative = async () => {
        const url = 'https://api.gmpapp.ru/save_negative';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, negative: negativeRef }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                if (negativeRef && !negative.includes(negativeRef)) {
                    setNegative((prevNegative) => [...prevNegative, negativeRef]);
                }
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
        finally {
            setNegativeRef('');
        }
    };

    const handleDeleteNegative = async (negativeToRemove) => {
        const url = 'https://api.gmpapp.ru/delete_negative';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, negative: negativeToRemove }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                setNegative((prevNegative) => prevNegative.filter(negative => negative !== negativeToRemove));
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
    };

    const handleShare = async () => {
        const shareLink = `Привет! Приглашаю в мою команду для канала **«${selectedGroup.name}»** в Give Me Public\nПерейдите по ссылке ниже, чтобы принять приглашение:\n`;
        const shareText = `https://t.me/GiveMePublicBot?start=share_${selectedGroup.id}`;

        const url = `https://t.me/share/url?url=${encodeURIComponent(shareLink)}&text=${encodeURIComponent(shareText)}`;

        tg.openTelegramLink(url);
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                {team.length > 0 ? (
                    <Section className='sectionChannelSources sectionSourceDone'>
                        {team.map((user, index) => (
                            <Collapse accordion>
                                <Collapse.Panel
                                    key={index}
                                    disabled={user.user_id === tg.initDataUnsafe.user.id}
                                    title={
                                        <div className='userCollapse'>
                                            <Avatar size={42} initials={user.name.slice(0, 1)} src={user.avatar} />
                                            <div className='userTitle'>
                                                <div className='userName'>{user.name}</div>
                                            </div>
                                        </div>
                                    }>
                                    <div className='shareContent'>
                                        <Button before={<Icon20CancelCircleOutline />} size='l' style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentRed.normal, marginTop: '10px' }} stretched onClick={() => deleteUser(user.name, user.user_id)}>Исключить</Button>
                                    </div>
                                </Collapse.Panel>
                            </Collapse>
                        ))}
                    </Section>
                ) : (
                    <div className='noFeeds'>
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={noUsersOpt}
                            height={150}
                            width={150}
                        />
                        <div className="welcome_no" style={{ justifyContent: 'center', textAlign: 'center' }}>
                            <Text className="welcomeHeadline" normalize={true} weight="1">Разделите администрирование со своими коллегами</Text>
                        </div>
                        <Text style={{ textAlign: "center" }} className="welcomeDesc" normalize={true} weight="3">Пригласите их по кнопке ниже</Text>
                    </div>
                )}
                <Button className="addChannel"
                    style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentBlue.normal, marginTop: '10px' }}
                    before={<Icon20ShareOutline />}
                    size='l'
                    stretched
                    onClick={handleShare}
                >
                    Пригласить
                </Button>
                {(
                    (team && team.some(user => user.user_id === tg.initDataUnsafe.user.id))
                ) && (
                        <Button appearance='negative' mode='link' before={<Icon20DoorEnterArrowRightOutline />} size='l' style={{ marginTop: '10px' }} onClick={logout} stretched >Выйти из команды</Button>
                    )}
            </AppRoot>
        </div>
    );
};

export default TeamPage;